module.exports = __webpack_public_path__ + "assets/img/checked1-de3c2d09.png";